import { createTheme, CSSVariablesResolver, Portal, Switch } from '@mantine/core';
import { dark, gray, red, pink, violet, blue, cyan, teal, green, yellow, orange } from './colors';

import { cssVariablesLightTheme } from '@datavant/design-tokens';

export const datavant = createTheme({
    colors: {
        dark,
        gray,
        red,
        pink,
        violet,
        blue,
        cyan,
        teal,
        green,
        yellow,
        orange,
    },
    primaryColor: 'blue',
    primaryShade: 5,
    fontFamily: '"DM Sans", sans-serif',
    // this is done so the out of the box mantine active styles aren't added to the DV ones
    activeClassName: '',
    components: {
        Switch: Switch.extend({
            // ✅ Disable withThumbIndicator if you want to use old styles.
            // V8 upgrade will enable this by default
            defaultProps: {
                withThumbIndicator: false,
            },
        }),
        Portal: Portal.extend({
            defaultProps: {
                // ✅ Disable reuseTargetNode by default if your application has z-index issues
                // V8 upgrade will enable this by default
                reuseTargetNode: false,
            },
        }),
    },
});

export const datavantResolver: CSSVariablesResolver = () => ({
    variables: {
        // override color vars e.g. --mantine-color-blue-0
        ...dark.reduce(
            (prev, current, index) => ({ ...prev, [`--mantine-color-dark-${index}`]: current }),
            {}
        ),
        ...gray.reduce(
            (prev, current, index) => ({ ...prev, [`--mantine-color-gray-${index}`]: current }),
            {}
        ),
        ...red.reduce((prev, current, index) => ({ ...prev, [`--mantine-color-red-${index}`]: current }), {}),
        ...pink.reduce(
            (prev, current, index) => ({ ...prev, [`--mantine-color-pink-${index}`]: current }),
            {}
        ),
        ...violet.reduce(
            (prev, current, index) => ({ ...prev, [`--mantine-color-violet-${index}`]: current }),
            {}
        ),
        ...blue.reduce(
            (prev, current, index) => ({ ...prev, [`--mantine-color-blue-${index}`]: current }),
            {}
        ),
        ...cyan.reduce(
            (prev, current, index) => ({ ...prev, [`--mantine-color-cyan-${index}`]: current }),
            {}
        ),
        ...teal.reduce(
            (prev, current, index) => ({ ...prev, [`--mantine-color-teal-${index}`]: current }),
            {}
        ),
        ...green.reduce(
            (prev, current, index) => ({ ...prev, [`--mantine-color-green-${index}`]: current }),
            {}
        ),
        ...yellow.reduce(
            (prev, current, index) => ({ ...prev, [`--mantine-color-yellow-${index}`]: current }),
            {}
        ),
        ...orange.reduce(
            (prev, current, index) => ({ ...prev, [`--mantine-color-orange-${index}`]: current }),
            {}
        ),
        '--button-radius': '1000px',
        '--ai-radius': '1000px',
        '--mantine-transition':
            'background-color ease-in-out 250ms, color ease-in-out 250ms, border-color ease-in-out 250ms',
        '--mantine-color-error': 'var(--mantine-color-red-5)',
        '--checkbox-color': 'var(--mantine-color-blue-5)',
        '--sc-color': 'var(--mantine-color-blue-5)',
    },
    light: cssVariablesLightTheme,
    dark: {},
});
